export const frontmatter = {
    "draft": true,
    "title": "Two-factor authentication",
    "description": "Set up two-factor authentication (2FA) in OnnIA.",
    "sidebar_label": "2FA",
    "sidebar_group": "reference",
    "sidebar_order": 4
}

export const toc = []